import React from "react"

const SizePerPageOptionRenderer = ({
    text,
    page,
    onSizePerPageChange
}: {
    text: string
    page: number
    onSizePerPageChange: Function
}): JSX.Element => {
    return (
        <li
            key={text}
            role="presentation"
            className="dropdown-item"
            onClick={(e) => {
                e.preventDefault()
                onSizePerPageChange(page)
            }}>
            <button
                tabIndex={-1}
                role="menuitem"
                data-page={page}
                onMouseDown={(e) => {
                    e.preventDefault()
                    onSizePerPageChange(page)
                }}
                className={"pagination-per-page"}>
                {text}
            </button>
        </li>
    )
}

export default SizePerPageOptionRenderer
